// extracted by mini-css-extract-plugin
module.exports = {"header":"Index_header__2jmX1","headerM":"Index_headerM__2X7sY","animationFade":"Index_animationFade__2VmOy"};